import React from "react";
import RangeSlider from "../../../../../../../../components/RangeSlider";
import styles from './Sliders.module.scss'
import Switch from "../../../../../../../../components/Switch";

export const HARDWARE_SLIDERS = {
    sliderCPU: {
        type: 'cpu',
        prop: 'cpu',
        title: 'Cores count',
        values: [1, 2, 4, 8, 16, 32],
        unit: 'core(s)',
    },
    sliderRAM: {
        type: 'ram',
        prop: 'ram',
        title: 'RAM amount',
        values: [1, 2, 4, 8, 16, 32],
        unit: 'Gb',
    },
    sliderStorage: {
        type: 'storage',
        prop: 'disk_size',
        title: 'Storage size',
        min: 10,
        max: 1000,
        step: 10,
        unit: 'Gb',
    },
}

export default function Sliders({
                                    currentCloud, selectSlider, selectSSD, bodyServer, requirements, hide
                                }) {

    const renderSliders = () => {

        let sliders = Object.keys(HARDWARE_SLIDERS).map(type => type);

        return sliders.map((type, index) => {
            if (!currentCloud.config || !currentCloud.config[type]) return null;
            let sliderData = HARDWARE_SLIDERS[type];

            return (
                <React.Fragment key={index}>
                <div className={styles['slider']}>
                    <p className={styles['slider__title']}>{sliderData.title}</p>
                    <RangeSlider
                        className={styles['slider__item']}
                        name={sliderData.prop}
                        value={bodyServer[sliderData.prop]}
                        // value={bodyServer[sliderData.prop] ? bodyServer[sliderData.prop] : 2}
                        onChange={result => {
                            if (result.value < requirements[sliderData.type]) return;
                            selectSlider({[result.name]: result.value})
                        }}
                        values={sliderData.values}
                        step={sliderData.step}
                        min={sliderData.min}
                        max={sliderData.max}
                        unit={sliderData.unit}
                    />
                </div>
                    {
                        sliderData.type === 'storage' && currentCloud.code === 'gc' &&
                        <Switch
                            className={styles.switch}
                            title='Use SSD over HDD'
                            value={bodyServer.disk_type === 'pd-ssd'}
                            onChange={selectSSD}
                        />
                    }
                </React.Fragment>
            )
        })
    }


    if (!!hide) return null;

    return renderSliders();
}